import { createSlice } from "@reduxjs/toolkit";
import {
  getAllActiveCities,
  getAllActiveHotels,
  getAllHotelCities,
  getHotelByURL,
  getHotelSpecialRate,
  insertWeblInquiry,
} from "@/services/hotel.services";
import { IHotelInitialState } from "@/types/hotel.types";

const initialState: IHotelInitialState = {
  loading: false,
  hotelSpecialRateLoading: false,
  InquiryLoading: false,
  error: "",
  HotelList: [],
  CityList: [],
  HotelCityList: [],
  HotelDetails: {},
  HotelRateDetails: {
    SingleOccupancyRate: null,
    DoubleOccupancyRate: null,
    ExtraPersonRate: null,
    ChildWithBedRate: null,
    ChildWithoutBedRate: null,
    SingleOccPurRate: null,
    DoubleOccPurRate: null,
    ExtraPerPurRate: null,
    CWBPurRate: null,
    CNBPurRate: null,
    MinAdultCount: null,
    MaxAdultCount: null,
    CWBCount: null,
    CNBCount: null,
  },
};

const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    clearHotelDetails: (state) => {
      state.HotelDetails = initialState.HotelDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveHotels.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveHotels.fulfilled, (state, action) => {
      state.loading = false;
      state.HotelList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveHotels.rejected, (state, action) => {
      state.loading = false;
      state.HotelList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHotelByURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHotelByURL.fulfilled, (state, action) => {
      state.loading = false;
      state.HotelDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getHotelByURL.rejected, (state, action) => {
      state.loading = false;
      state.HotelDetails = initialState.HotelDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllHotelCities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllHotelCities.fulfilled, (state, action) => {
      state.loading = false;
      state.HotelCityList = action.payload || [];
    });
    builder.addCase(getAllHotelCities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.HotelCityList = [];
    });

    builder.addCase(getAllActiveCities.pending, (state) => {
      state.error = "";
    });
    builder.addCase(getAllActiveCities.fulfilled, (state, action) => {
      state.CityList = action.payload || [];
    });
    builder.addCase(getAllActiveCities.rejected, (state, action) => {
      state.error = action.error.message || "Something went wrong";
      state.CityList = [];
    });

    builder.addCase(insertWeblInquiry.pending, (state) => {
      state.InquiryLoading = true;
      state.error = "";
    });
    builder.addCase(insertWeblInquiry.fulfilled, (state) => {
      state.InquiryLoading = false;
    });
    builder.addCase(insertWeblInquiry.rejected, (state, action) => {
      state.InquiryLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getHotelSpecialRate.pending, (state) => {
      state.hotelSpecialRateLoading = true;
      state.error = "";
    });
    builder.addCase(getHotelSpecialRate.fulfilled, (state, action) => {
      state.hotelSpecialRateLoading = false;
      state.HotelRateDetails = action.payload;
    });
    builder.addCase(getHotelSpecialRate.rejected, (state, action) => {
      state.hotelSpecialRateLoading = false;
      state.error = action.error.message || "Something went wrong";
      state.HotelRateDetails = initialState.HotelRateDetails;
    });
  },
});

export default hotelSlice.reducer;
export const { clearHotelDetails } = hotelSlice.actions;
